export const USER_STALE = 60 * 60 * 1000 // 1h
